import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import api from "../../api.js";

const EditProfileModal = ({ show, onClose, user, onUpdate }) => {
  const [formData, setFormData] = useState({
    username: user.username,
    email: user.email,
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [loading, setLoading] = useState(false);
  const token = Cookies.get("access_token");
  const currentuser = Cookies.get("user_id");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);

    // Password validation
    if (formData.new_password && formData.new_password !== formData.confirm_password) {
      alert("رمز عبور جدید و تکرار آن یکسان نیستند.");
      setLoading(false);
      return;
    }

    const dataToSend = {
      username: formData.username,
      email: formData.email,
    };

    // Only include password change if fields are filled
    if (formData.old_password && formData.new_password) {
      dataToSend.old_password = formData.old_password;
      dataToSend.new_password = formData.new_password;
    }

    try {
      const res = await api.patch(
        `/profile/${currentuser}/`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert("پروفایل با موفقیت بروزرسانی شد");
      onUpdate(res.data);
      onClose();
    } catch (err) {
      alert("خطا در بروزرسانی پروفایل. لطفا اطلاعات وارد شده را بررسی کنید.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>ویرایش پروفایل</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>نام کاربری</Form.Label>
            <Form.Control
              name="username"
              value={formData.username}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>ایمیل</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Form.Group>

          <hr className="my-4" />
          <h5>تغییر رمز عبور (اختیاری)</h5>

          <Form.Group className="mt-3">
            <Form.Label>رمز عبور فعلی</Form.Label>
            <Form.Control
              type="password"
              name="old_password"
              value={formData.old_password}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>رمز عبور جدید</Form.Label>
            <Form.Control
              type="password"
              name="new_password"
              value={formData.new_password}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>تکرار رمز عبور جدید</Form.Label>
            <Form.Control
              type="password"
              name="confirm_password"
              value={formData.confirm_password}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-edit" variant="secondary" onClick={onClose}>
          لغو
        </Button>
        <Button className="btn-submit" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "ذخیره"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditProfileModal;
